<template>
  <div class="video-player-bk">
    <!-- 123 -->
    <video-player class="video-player" :options="playerOptions" />
	<img class="backtBtn" src="../assets/btn/teacher-back.gif" alt="" @click="goPath">
  </div>
</template>
<script>
// 在组件中引入
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  // 注册
  components: { videoPlayer },
  name: 'shipin',
  computed: {
    playerOptions () {
      return {
        sources: [
          {
            type: 'video/mp4',
            src: this.videoUrl
          }
        ],
        // 其他可配置选项，如播放速度、是否自动播放等，可根据需求设置
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: true,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        // fluid: true,
        poster: '',
        notSupportedMessage: '此视频播放器需要更新',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
        // 其他选项...
      }
    }
  },
  data () {
    return {
      videoUrl: 'https://app.hebyun.com.cn/avm/material/avm/2024/11/05/473c3e5886b74f66b51a7dabcfbb37de.mp4',
	  type:'',
    }
  },
  mounted () {
    let id = this.$route.query.videoId
	this.type=id
    if (id == 1) {//翟少鹏
      this.videoUrl = '../video/teacher1.mp4'
    } else if (id == 2) {//黄小凤
      this.videoUrl = '../video/teacher2.mp4'
    } else if (id == 3) {//张晓威
      this.videoUrl = '../video/teacher3.mp4'
    } else if (id == 4) {//出发页
      this.videoUrl = '../video/go.mp4'
    }
  },
  methods: {
    onPlayerPause (player) {
      console.log('player pause!', player)
    },
    onPlayerPlay (player) {
      console.log('player play!', player)
    },
    onFullscreenChange (isFullScreen) {
      console.log('player screen change!', isFullScreen)
    },
    fullScreen () {
      this.$refs.videoPlayer.fullScreen()
    },
	goPath() {
		// console.log('111')
		if(this.type==1){
			this.$router.push({
				path: '/teacherOne',
				query: {
				}
			})
		}else if(this.type==2){
			this.$router.push({
				path: '/teacherTwo',
				query: {
				}
			})
		}else if(this.type==3){
			this.$router.push({
				path: '/teacherThree',
				query: {
				}
			})
		}else{
			this.$router.push({
				path: '/bgTwo',
				query: {
				}
			})
		}
	},
  }
}
</script>
<style lang="scss" scoped>
// .video-js .vjs-big-play-button {
//   width: 72px;
//   height: 72px;
//   border-radius: 100%;
//   z-index: 100;
//   background-color: #ffffff;
//   border: solid 1px #979797;
// }

.video-player-bk {
  width: 100%;
  height: 100%;
  background: url('../assets/bg.png');
  background-size: cover;
  position: relative;

  .video-player {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    width: 100%;
    height: 300px;
  }
}
.backtBtn {
	position:absolute;
    width: 110px;
    left: 32%;
    bottom: 13px;
  }
</style>